/**
 * Created by Jonas Wålekvist on 2018-05-02.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineMax} from "gsap";
import {DungeonQuestLayerConfig} from "../../../config/DungeonQuestLayerConfig";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";

export class DungeonQuestFreeSpinFeatureView extends BaseView {
    private _overlays:TimelineSprite[];
    private _layer:ScalableLayer;
    private _idleLoop:TimelineMax | null;

    constructor(resourceGroup?:ResourcesGroupName) {
        super(resourceGroup);
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.SYMBOLS_OVERLAY.name);
        this._layer.addChild(this);
        this._overlays = [];
    }


    public addOverlays(positions:[number, number][]) {
        for(let position of positions) {
            this.addOverlayAt(position);
        }
        this.startLoop();
    }

    public startLoop():void {
        this.stopLoop();
        this._idleLoop = new TimelineMax({repeat : -1});
        for(let i:number = 0; i < this._overlays.length; i++) {
            this._idleLoop.add(this._overlays[i].getAnimation(), Math.random() * 0.5);
        }

    }

    public stopLoop():void {
        if(this._idleLoop) {
            this._idleLoop.kill();
            this._idleLoop = null;
        }
    }

    private addOverlayAt(position:[number, number]) {
        const sprite = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.WILD_STICKY_SYMBOL_IDLE));
        sprite.anchor.set(0, 0.5);
        sprite.position.set(position[0] * GameConfig.instance.SYMBOL_WIDTH + 10, position[1] * GameConfig.instance.SYMBOL_HEIGHT + GameConfig.instance.SYMBOL_HEIGHT * 0.5 - 5);
        sprite.position.x = sprite.position.x + (GameConfig.instance.SYMBOL_WIDTH - sprite.width) / 2;
        this._overlays.push(sprite);
        this.addChild(sprite);
    }

    public clearAllOverlaySymbols() {
        this.stopLoop();
        this._overlays = [];
        this.removeChildren();
    }

}